import type { ReactNode } from 'react';

import BulkSelectionCheckbox from '../../BulkSelectionCheckbox';
import BulkSelectionSingleCheckbox from '../../BulkSelectionSingleCheckbox';
import { BULK_SELECTION_COLUMN_WIDTH } from '../constants';
import type { TableColumn } from '../types';

export const getTableBulkSelectionColumn = <T extends { id: string }>(
  data: T[],
  tableId: string,
  columnConfig: Partial<TableColumn> = {}
): TableColumn<T> => {
  const dataIds: string[] = data.map((item: T) => item.id);

  return {
    key: 'bulkSelection',
    bulkSelection: true,
    sortable: false,
    width: BULK_SELECTION_COLUMN_WIDTH,
    title: <BulkSelectionCheckbox dataIds={dataIds} selectionId={tableId} />,
    render: (_, { id }: T): ReactNode => {
      if (!id) {
        return null;
      }

      return <BulkSelectionSingleCheckbox itemId={id} selectionId={tableId} />;
    },
    ...columnConfig
  };
};
